// /src/components/CcpConstants/GetCoordIds.js
import { useState, useEffect } from "react";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import useData from "../Dashboard/hooks/SchoolInfoHook";

const GetCoordIds = (schoolId) => {
  const db = getFirestore();
  const [pathwayEmail, setPathwayEmail] = useState("");
  const [opEmail, setOpEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { data: schoolInfo, loading: schoolInfoLoading } = useData(schoolId);

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        if (schoolInfo && schoolInfo.length > 0) {
          const pathwayId = schoolInfo[0].pathway;
          const operationsId = schoolInfo[0].operations;

          const [pathwayDoc, operationsDoc] = await Promise.all([
            pathwayId ? getDoc(doc(db, "users", pathwayId)) : null,
            operationsId ? getDoc(doc(db, "users", operationsId)) : null,
          ]);

          setPathwayEmail(pathwayDoc?.exists() ? pathwayDoc.data().email : "");
          setOpEmail(operationsDoc?.exists() ? operationsDoc.data().email : "");
        } else {
          console.log("No school info found for id: ", schoolId);
        }
      } catch (err) {
        console.error("Error fetching coordinator emails:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    // Call fetchEmails immediately, but it will only fetch emails if school info is available
    fetchEmails();
  }, [schoolId, db, schoolInfo, schoolInfoLoading]); // Ensure schoolInfoLoading is in the dependency array

  return { pathwayEmail, opEmail, loading, error };
};

export default GetCoordIds;
